module.exports = __webpack_public_path__ + "img/arrows-maximize.4d4ff952.svg";